import { render, staticRenderFns } from "./CreateView.vue?vue&type=template&id=cee0db2e&scoped=true"
import script from "./CreateView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CreateView.vue?vue&type=style&index=0&id=cee0db2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cee0db2e",
  null
  
)

export default component.exports